<section class="flex flex-col items-center gap-12">
  <app-section-header
    icon="@tui.sparkles"
    subtitle="Enterprise Features"
    title="Built for enterprise teams"
    description="Advanced collaboration, security, and compliance features that grow with your organization"
  />
  <div class="grid w-full grid-cols-1 gap-8 sm:grid-cols-2">
    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.users" class="mr-2" />
        <h3 class="text-xl font-bold">Organizations and Teams</h3>
      </div>
      <p class="text-pretty text-lg">
        Organize your projects across multiple teams and departments with
        centralized management and billing. Scale your development workflow with
        dedicated workspaces for each team.
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.shield-check" class="mr-2" />
        <h3 class="text-xl font-bold">Role-Based Access Control</h3>
      </div>
      <p class="text-pretty text-lg">
        Fine-grained permissions to control who can access, deploy updates,
        trigger builds, and publish apps. Assign roles and permissions that
        align with your organizational structure and security requirements.
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.credit-card" class="mr-2" />
        <h3 class="text-xl font-bold">Enterprise Billing</h3>
      </div>
      <p class="text-pretty text-lg">
        Simplified billing management with consolidated invoicing and flexible
        payment options. Tailored plans to fit your organization's budget and
        usage patterns.
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.key" class="mr-2" />
        <h3 class="text-xl font-bold">SSO + 2FA</h3>
      </div>
      <p class="text-pretty text-lg">
        Integrate with your identity provider and enforce multi-factor
        authentication across your organization. Secure your platform with
        enterprise-grade authentication controls.
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.database" class="mr-2" />
        <h3 class="text-xl font-bold">Flexible Data Retention</h3>
      </div>
      <p class="text-pretty text-lg">
        Configure data retention policies to meet your compliance requirements
        and storage needs. Maintain control over your data lifecycle with
        customizable retention and deletion policies.
      </p>
    </div>

    <div
      class="flex flex-col gap-4 rounded-[--tui-radius-l] bg-background-neutral-1 p-4 md:p-6"
    >
      <div class="flex flex-row items-center">
        <tui-icon icon="@tui.file-text" class="mr-2" />
        <h3 class="text-xl font-bold">Audit Logs</h3>
      </div>
      <p class="text-pretty text-lg">
        Track all platform activities with comprehensive audit logs. Monitor
        user actions, deployments, and configuration changes for compliance and
        security.
      </p>
    </div>
  </div>
</section>
